import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { SupportAgentTicket } from "@src/types/support";

export const patchTicketStatus = async (
  namespace: string,
  ticketId: string,
  newStatus: string,
) => {
  const url = supportUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.patch<SupportAgentTicket>(
      `${url}/api/v1/ns/${namespace}/tickets/${ticketId}`,
      { status: newStatus },
      {
        headers: headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to update ticket status. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while updating ticket status.",
      );
    }
  }
};
